<template lang="pug">
    #site-header
        .menu-icon
        .logo
            .image
</template>
<script>
export default {
  name: 'SiteHeader',
  data() {
    return {}
  },

  mounted() {
  }
}
</script>